import loadable from '@loadable/component'

export default {
    '/:type/topic': loadable(() => import('./list')),
    '/:type/topic/:topicId/': loadable(() => import('./courseQuizDetail'))
}
